import { KeyRound } from "lucide-react";

import useTranslations from "@/shared/lang/useTranslations";

import { MonoValue } from "../shared/CryptoSwapBits";

/** Where the pesos land: read-only, it is the organization's own key. */
export function SellPayoutKey({ keyValue }: { keyValue: string | null }) {
  const { t } = useTranslations("cryptoSwaps");
  if (!keyValue) return null;

  return (
    <div className="flex items-start gap-3 rounded-2xl border border-border bg-muted/40 p-4">
      <span className="flex size-9 shrink-0 items-center justify-center rounded-full border border-border bg-background text-foreground">
        <KeyRound aria-hidden="true" className="size-4" />
      </span>
      <div className="flex min-w-0 flex-col gap-0.5">
        <span className="text-xs text-muted-foreground">{t("sell_payout_title")}</span>
        <MonoValue breakAll className="text-base font-semibold text-foreground">
          {keyValue}
        </MonoValue>
        <span className="text-[13px] leading-relaxed text-muted-foreground">{t("sell_payout_note")}</span>
      </div>
    </div>
  );
}
